export const settingsErrorMessage = "Failed to update settings.";

export const defaultErrorMessage = 'An error occured.';

export const settingsUpdatedMessageConfig = 
  {
    messageType: "toast",
    config: {
      content: "Settings updated successfully!",
    },
  } as const;

export const settingsErrorMessageConfig = 
  {
    messageType: "banner",
    config: {
      tone: "critical",
      title: "Error",
      text: settingsErrorMessage,
    },
  } as const;
